import { render, staticRenderFns } from "./GoodsSettings.vue?vue&type=template&id=c4327058&"
import script from "./GoodsSettings.vue?vue&type=script&lang=js&"
export * from "./GoodsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports